const fetchDataPagination = (action, state) => {
  return {
    currentPageNumber: action.data && action.data.currentPageNumber ||
      state.pagination.currentPageNumber,
    resultPerPage: action.data && action.data.resultPerPage ||
      state.pagination.resultPerPage,
    lastSortedColumnValueNext: action.data && action.data.lastSortedColumnValueNext ||
      state.pagination.lastSortedColumnValueNext,
    lastSortedColumnValuePrev: action.data && action.data.lastSortedColumnValuePrev ||
      state.pagination.lastSortedColumnValuePrev,
    lastRowIdNext: action.data && action.data.lastItemIdNext ||
      state.pagination.lastRowIdNext,
    lastRowIdPrev: action.data && action.data.lastItemIdPrev ||
      state.pagination.lastRowIdPrev,
    isNextPresent: action.data && action.data.isNextPresent,
    nextOrPrev: action.data && action.data.nextOrPrev ||
      state.pagination.nextOrPrev,
  };
};

export {
  fetchDataPagination,
};
